declare global {
  interface Window {
    Intercom: (...args: unknown[]) => void;
    intercomSettings: Record<string, unknown>;
  }
}

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

export function initIntercom() {
  if (!INTERCOM_APP_ID) return;

  // Load Intercom script
  const script = document.createElement('script');
  script.innerHTML = `
    (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${INTERCOM_APP_ID}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
  `;
  document.head.appendChild(script);
}

export function bootIntercom(user?: { name: string; email: string; userId?: number }) {
  if (!INTERCOM_APP_ID || !window.Intercom) return;

  if (user) {
    window.Intercom('boot', {
      app_id: INTERCOM_APP_ID,
      name: user.name,
      email: user.email,
      user_id: user.userId?.toString(),
    });
  } else {
    window.Intercom('boot', {
      app_id: INTERCOM_APP_ID,
    });
  }
}

export function shutdownIntercom() {
  if (!window.Intercom) return;
  window.Intercom('shutdown');
}

export function updateIntercom() {
  if (!window.Intercom) return;
  window.Intercom('update');
}
